import activityLogs from './activity-logs';
import affiliate from './affiliate';
import api from './api';
import auth from './auth';
import aws from './aws';
import button from './button';
import cloudHosting from './cloud-hosting';
import cloudServer from './cloud-server';
import common from './common';
import contact from './contact';
import contract from './contract';
import dashboard from './dashboard';
import dialog from './dialog';
import domain from './domain';
import error from './error';
import fortuneWheel from './fortune-wheel';
import invoicePrinting from './invoice-printing';
import invoices from './invoices';
import loyalty from './loyalty';
import maintenance from './maintenance';
import message from './message';
import navbar from './navbar';
import notification from './notification';
import payment from './payment';
import popupReminder from './popup-reminder';
import product from './product';
import profile from './profile';
import promoCredit from './promo-credit';
import region from './region';
import sharedHosting from './shared-hosting';
import sidebar from './sidebar';
import sms from './sms';
import ssl from './ssl';
import table from './table';
import wallet from './wallet';
import withdraw from './withdraw';
import wpHosting from './wp-hosting';

export default {
    common,
    dashboard,
    message,
    sidebar,
    table,
    invoices,
    profile,
    button,
    error,
    dialog,
    domain,
    notification,
    wallet,
    'cloud-server': cloudServer,
    'cloud-hosting': cloudHosting,
    shared_hosting: sharedHosting,
    withdraw,
    sms,
    navbar,
    maintenance,
    invoice_printing: invoicePrinting,
    contact,
    api,
    payment,
    aws,
    promo_credit: promoCredit,
    product,
    auth,
    affiliate,
    wp_hosting: wpHosting,
    loyalty,
    fortune_wheel: fortuneWheel,
    ssl,
    activity_logs: activityLogs,
    region,
    popup_reminder: popupReminder,
    contract,
};
